import ComponentBase from '../base/component-base';
import {
  EVENT_CART_OPERATION_START,
  EVENT_CART_OPERATION_END,
} from '../../constants/event';

/**
 * Product Actions Component
 * Manages the product actions container (add to cart, buy now, etc.)
 * Handles loading states for all actions within the container
 * Multiple instances can exist on the same page
 */
class ProductActions extends ComponentBase {
  private spinnerElement: HTMLElement | null = null;
  private innerElement: HTMLElement | null = null;
  private onCartOperationStartBinding: () => void;
  private onCartOperationEndBinding: () => void;

  constructor(element: HTMLElement) {
    super(element);

    console.log('[ProductActions] Initializing product actions:', element);

    // Bind event handlers
    this.onCartOperationStartBinding = this.onCartOperationStart.bind(this);
    this.onCartOperationEndBinding = this.onCartOperationEnd.bind(this);

    this.init();
  }

  protected init(): void {
    // Find child elements
    this.innerElement = this.element.querySelector('.c-product-actions__inner');
    this.spinnerElement = this.element.querySelector('.c-product-actions__spinner');

    console.log('[ProductActions] Elements:', {
      innerElement: this.innerElement,
      spinnerElement: this.spinnerElement,
    });

    // Add event listeners
    document.addEventListener(EVENT_CART_OPERATION_START, this.onCartOperationStartBinding);
    document.addEventListener(EVENT_CART_OPERATION_END, this.onCartOperationEndBinding);

    console.log('[ProductActions] Event listeners attached');
  }

  private onCartOperationStart(): void {
    console.log('[ProductActions] Cart operation started - adding is-loading class');
    this.element.classList.add('is-loading');

    if (this.innerElement) {
      this.innerElement.setAttribute('aria-busy', 'true');
    }
  }

  private onCartOperationEnd(): void {
    console.log('[ProductActions] Cart operation ended - removing is-loading class');
    this.element.classList.remove('is-loading');

    if (this.innerElement) {
      this.innerElement.setAttribute('aria-busy', 'false');
    }
  }

  protected onDestroy(): void {
    super.onDestroy();

    document.removeEventListener(EVENT_CART_OPERATION_START, this.onCartOperationStartBinding);
    document.removeEventListener(EVENT_CART_OPERATION_END, this.onCartOperationEndBinding);
  }
}

export default ProductActions;
